import { render, staticRenderFns } from "./PlanPartnerAgent.vue?vue&type=template&id=54e8e974&scoped=true"
import script from "./PlanPartnerAgent.vue?vue&type=script&lang=js"
export * from "./PlanPartnerAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e8e974",
  null
  
)

export default component.exports